"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function initialize(props) {
    const { alternative_payment_methods } = (0, checkout_frontend_library_1.getOrderInitialData)();
    (0, src_1.setOnAction)(props.onAction);
    if (alternative_payment_methods) {
        alternative_payment_methods.forEach(paymentMethod => {
            const type = paymentMethod.type;
            switch (type) {
                case checkout_frontend_library_1.alternatePaymentMethodType.STRIPE:
                    (0, src_1.initStripe)(paymentMethod);
                    break;
                case checkout_frontend_library_1.alternatePaymentMethodType.PAYPAL:
                    (0, src_1.initPaypal)(paymentMethod);
                    break;
                case 'braintree':
                    (0, src_1.initBraintreeGoogle)(paymentMethod);
                    break;
                case checkout_frontend_library_1.alternatePaymentMethodType.BRAINTREE_APPLE:
                    (0, src_1.initBraintreeApple)(paymentMethod);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log('do nothing'); // TODO Implement the default behaviour.
                    break;
            }
        });
    }
}
exports.initialize = initialize;
